import { apiService } from '@/services/api'
import { config } from '@/config/env'

export interface CreateSupplierInvitationRequest {
  legalName: string
  tradeName: string
  rfc: string
  serviceTypeId: string
  contactPhone: string
  email: string
  /** ID interno en SAI (1-99999). Opcional: se omite si no se captura. */
  saiSupplierId?: number
}

export interface CreateSupplierInvitationResponse {
  id: string
  token: string
  legalName: string
  tradeName: string
  rfc: string
  email: string
  status: string
  expiresAt: string
  message: string
}

export interface InvitationData {
  legalName: string
  tradeName: string
  rfc: string
  email: string
  contactPhone: string
  serviceTypeId: string
  personType: string
  vatType: string
  expiresAt: string
  status: string
}

export interface RegisterByInvitationRequest {
  token: string
  password: string
  personType: string
  vatType: string
  mainContactName: string
  mainContactPhone: string
  salesEmail: string
  accountsPayableEmail: string
  internalRequesterName: string
  acceptTerms: boolean
  country: string
  state: string
  city: string
  postalCode: string
}

export interface RegisterByInvitationResponse {
  message: string
  supplierId: string
  status: string
}

export const createSupplierInvitation = async (
  data: CreateSupplierInvitationRequest
): Promise<CreateSupplierInvitationResponse> => {
  const response = await apiService.request<CreateSupplierInvitationResponse>(
    '/internal/suppliers/invitations',
    {
      method: 'POST',
      body: JSON.stringify(data)
    }
  )
  return response
}

export const getInvitationByToken = async (
  token: string
): Promise<InvitationData> => {
  const response = await fetch(`${config.apiBaseUrl}/suppliers/invitations/token/${token}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
  })
  
  if (!response.ok) {
    throw new Error('Token inválido o expirado')
  }
  
  return await response.json()
}

export const registerByInvitation = async (
  data: RegisterByInvitationRequest
): Promise<RegisterByInvitationResponse> => {
  const response = await fetch(`${config.apiBaseUrl}/suppliers/auth/register/invitation`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  })
  
  if (!response.ok) {
    const error = await response.json()
    throw new Error(error.message || 'Error al registrar el proveedor')
  }
  
  return await response.json()
}
